module.exports = __webpack_public_path__ + "static/media/zombies1.17dada98.jpg";